import { aboutData } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">{aboutData.title}的使命与愿景</p>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center mb-10 max-w-[700px] mx-auto">
            {aboutData.description}
          </p>

          {/* Highlights */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {aboutData.highlights.map((h, i) => (
              <div key={i} className="text-center p-5 bg-background-50 rounded-xl border border-background-200/70">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading mb-1">
                  {h.value}
                </div>
                <div className="text-xs text-foreground-500">{h.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}